import Select from "react-select";

import CustomInput from "./CustomInput";
import { Option } from "./SelectInput";

type MultiSelectColumnInputProps = {
  setFilter: Function;
  label?: string;
  value?: string[];
  id?: string;
  options: string[];
};

const MultiSelectColumnInput = (props: MultiSelectColumnInputProps) => {
  const { setFilter, label, value, id, options } = props;
  return (
    <CustomInput label={label} id={id}>
      <Select
        name={id}
        options={options.map((v: any) => ({
          value: v,
          label: v,
        }))}
        value={
          value &&
          value.map((v: any) => ({
            value: v,
            label: v,
          }))
        }
        isMulti={true}
        onChange={(selection) => {
          setFilter(selection.map((newValue: Option) => newValue.value));
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "var(--blue10)",
            primary50: "var(--blue15)",
            primary75: "var(--blue25)",
            primary: "var(--blue)",

            dangerLight: "var(--lightNoteRed)",
            danger: "var(--red)",
          },
        })}
        className="CustomInput__container__multiSelect"
        classNamePrefix="CustomInput__container__multiSelect"
      />
    </CustomInput>
  );
};

export default MultiSelectColumnInput;
